import React from 'react'
import { useTranslation } from "react-i18next";
import { Controller } from 'react-hook-form'

import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import { makeStyles } from '@mui/styles'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

const useStyles = makeStyles(theme => ({
  label: {
    color: '#9c9c9c !important',
    paddingLeft: '0 !important',
    transform: 'translate(0, 18px) scale(1) !important',
    transformOrigin: 'top left !important',
    '&.MuiFormLabel-filled': {
      display: 'none',
    },
    '&.MuiFormLabel-root.Mui-focused': {
      color: '#9c9c9c !important',
    },
    '&.MuiFormLabel-root.Mui-error': {
      color: '#9c9c9c !important',
    },
  },
}))

export default function CustomSelect({ id, label, options, control, rules, error, helperText }) {
  const { t } = useTranslation();
  const classes = useStyles()
  const { spacing } = useTheme()

  return (
    <div style={{ padding: spacing(2, 0) }}>
      <Typography variant="caption" color={error === undefined ? 'textSecondary' : 'error'}>
        {label}
      </Typography>
      <FormControl style={{ marginTop: spacing(-4), width: '100%' }} error={error !== undefined}>
        <InputLabel id={`${id}-label`} shrink={false} className={classes.label}>
            {t("Word.PleaseSelect")}
        </InputLabel>
        <Controller
          render={({ field }) => (
            <Select
              {...field}
              color="secondary"
              variant="standard"
              labelId={`${id}-label`}
              id={id}
              placeholder={t("Word.PleaseSelect")}
              inputProps={{ style: { paddingLeft: 0 } }}
            >
              {options.map(({ label, value }) => (
                <MenuItem key={value} value={value}>
                  {label}
                </MenuItem>
              ))}
            </Select>
          )}
          defaultValue=""
          control={control}
          name={id}
          rules={rules}
        />
        {Boolean(helperText) && <FormHelperText style={{ marginLeft: 0 }}>{helperText}</FormHelperText>}
        {error && <FormHelperText error style={{ marginLeft: 0 }}>必須項目です</FormHelperText>}
      </FormControl>
    </div>
  )
}
